import './instrument';

import React from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from '@sentry/react';
import './index.css';
import App from './App';

function sentryErrorFallback({ resetError }) {
  return (
    <div
      style={{
        padding: 24,
        fontFamily: 'system-ui, sans-serif',
        maxWidth: 480,
        margin: '12vh auto',
        color: '#e5e5e5',
        background: '#0a0a0a',
        borderRadius: 12,
        border: '1px solid #262626',
      }}
    >
      <h1 style={{ fontSize: '1.125rem', margin: '0 0 12px', fontWeight: 700 }}>
        Something went wrong
      </h1>
      <p style={{ color: '#a3a3a3', margin: '0 0 20px', lineHeight: 1.5, fontSize: '0.9375rem' }}>
        An unexpected error occurred. You can try again or reload the page.
      </p>
      <button
        type="button"
        onClick={resetError}
        style={{
          padding: '10px 18px',
          borderRadius: 8,
          border: 'none',
          fontWeight: 600,
          cursor: 'pointer',
          background: '#22c55e',
          color: '#0a0a0a',
        }}
      >
        Try again
      </button>
    </div>
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Sentry.ErrorBoundary fallback={sentryErrorFallback} showDialog={false}>
    <React.StrictMode>
      <App />
    </React.StrictMode>
  </Sentry.ErrorBoundary>
);
